import { Content } from "pdfmake/interfaces";
import HeaderSapiensForm from "react-lib/apps/HISV3/DPO/sequence/HeaderSapiensForm";

import CONFIG from "config/config";

const FormEmployeeAttendanceReport = async (props: any) => {
  var origin = window?.location?.origin;

  const getHospitalAddress = (): Content => {
    return {
      columns: [
        { text: '', width: '*' },
        {
          width: 'auto',
          table: {
            body: [
              [
                {
                  alignment: 'right',
                  margin: [0, 0, 5, 0],
                  border: [false, false, true, false],
                  stack: [
                    {
                      font: 'KanitLM',
                      style: 'hospitalName',
                      text: 'โรงพยาบาลเอ็มเอสเค',
                    },
                    {
                      font: 'KanitLM',
                      style: 'hospitalInfo',
                      text: 'เลขที่ 118 ถ. สาทรเหนือ แขวงสีลม',
                    },
                    {
                      font: 'KanitLM',
                      style: 'hospitalInfo',
                      text: 'เขตบางรัก กรุงเทพมหานคร 10500',
                    },
                  ],
                },
                {
                  alignment: 'right',
                  margin: [5, 0, 0, 0],
                  border: [true, false, false, false],
                  stack: [
                    {
                      font: 'KanitLM',
                      style: 'hospitalName',
                      text: 'MSK Hospital',
                    },
                    {
                      font: 'KanitLM',
                      style: 'hospitalInfo',
                      text: '118, Sathon Nuea Rd., Silom,',
                    },
                    {
                      font: 'KanitLM',
                      style: 'hospitalInfo',
                      text: 'Bang Rak, Bangkok 10500',
                    },
                  ],
                },
              ],
            ],
          },
          layout: {
            hLineWidth: () => 0,
            vLineWidth: (i) => (i === 1 ? 0.75 : 0),
            vLineColor: () => 'black',
          },
        },
      ],
      margin: [0, 0, 20, 0]
    };
  };

  const headerSapiensForm = await HeaderSapiensForm({
    form: "FormReceipt",
    logoHight: CONFIG.COMPANY === "MSK" ? 60 : 24,
    pageMargins: props?.pageMargins || [0, 100, 0, 30],
    hospitalAddress: getHospitalAddress(),
    titleMargins: [0, 16, 0, 0],
    logoMargins: [0, -8, 0, 0],
    header: {
      margin: [-8, 0, 0, 0],
      stack: [
        {
          margin: [0, 0, 0, 0],
          table: {
            widths: ["*"],
            body: [
              [
                {
                  text: [
                    {
                      text: "Employee Attendance Report",
                      font: "KanitLM",
                      style: {
                        bold: true,
                        fontSize: 12,
                      },
                    },
                  ],
                  alignment: "center",
                  border: [false, false, false, false],
                },
              ],
            ],
          },
        },
      ],
    },
    styles: {
      reportHeader: {
        bold: true,
        fontSize: 9,
      },
      reportInfo: {
        fontSize: 9,
      },
    },
  });

  function buildEmployeeInfo(record: any, summary: any): Content {
    return {
      stack: [
        {
          columns: [
            { text: 'Employee ID', style: 'reportHeader', width: 'auto', noWrap: true },
            { text: record.employee_id, style: 'reportInfo', margin: [8, 0, 2, 0], width: 'auto', noWrap: true },
            { text: 'Employee name', style: 'reportHeader', margin: [25, 0, 2, 0], width: 'auto', noWrap: true },
            { text: record.employee_name, style: 'reportInfo', margin: [8, 0, 2, 0], width: 'auto', noWrap: true },
            { text: 'Position', style: 'reportHeader', margin: [25, 0, 2, 0], width: 'auto', noWrap: true },
            { text: record.employee_position, style: 'reportInfo', margin: [8, 0, 2, 0], width: 'auto', noWrap: true },
            { text: 'Employment type', style: 'reportHeader', margin: [25, 0, 2, 0], width: 'auto', noWrap: true },
            { text: record.employee_employment_type, style: 'reportInfo', margin: [8, 0, 2, 0], width: 'auto', noWrap: true },
          ]
        },
        {
          columns: [
            { text: 'No. of Day shift', style: 'reportHeader', width: 'auto', noWrap: true },
            { text: summary.D, style: 'reportInfo', margin: [8, 0, 0, 0], width: 'auto', noWrap: true },
            { text: 'No. of Night shift', style: 'reportHeader', margin: [25, 0, 0, 0], width: 'auto', noWrap: true },
            { text: summary.N, style: 'reportInfo', margin: [8, 0, 0, 0], width: 'auto', noWrap: true }
          ],
          margin: [0, 5, 0, 0]
        }
      ],
      margin: [20, 0, 20, 10]
    };
  }

  function buildTableSection(body: any[][], pageBreak?: 'after' | 'before'): Content {
    const headerRow = [
      { text: 'Date', style: 'tableHeader' },
      {
        text: [
          'Shift time ',
          { text: '(Breaking)', italics: true }
        ],
        style: 'tableHeader',
      },
      { text: 'Type', style: 'tableHeader', alignment: 'center' },
      { text: 'Clock-in', style: 'tableHeader', alignment: 'center' },
      { text: 'Clock-out', style: 'tableHeader', alignment: 'center' },
      { text: 'Late (min)', style: 'tableHeader', alignment: 'center' },
      { text: 'Early out (min)', style: 'tableHeader', alignment: 'center' },
      { text: 'Leave', style: 'tableHeader', alignment: 'center' },
      { text: 'Leave hour (hr)', style: 'tableHeader', alignment: 'center' },
      { text: 'OT (hr)', style: 'tableHeader', alignment: 'center' },
      { text: 'Actual work (hr)', style: 'tableHeader', alignment: 'center' },
    ];

    const processedBody: any[][] = [];
    let currentGroup: any[][] = [];
    let lastDate = '';

    const pushGroup = () => {
      if (currentGroup.length === 0) return;

      const rowSpan = currentGroup.length;
      for (let i = 0; i < rowSpan; i++) {
        const row = [...currentGroup[i]];

        if (i === 0) {
          row[0] = {
            ...row[0],
            rowSpan: rowSpan,
          };
        } else {
          row[0] = {
            text: '',
            border: [false, false, false, false],
          };
        }

        processedBody.push(row);
      }

      currentGroup = [];
    };

    for (const row of body) {
      const dateCell = row[0];
      const dateText = typeof dateCell.text === 'string' ? dateCell.text.trim() : '';

      if (dateText !== '' && dateText !== lastDate) {
        pushGroup();
        lastDate = dateText;
      }

      currentGroup.push(row);
    }

    pushGroup();

    return {
      table: {
        headerRows: 1,
        widths: ['10%', '14%', '6%', '7%', '7%', '8%', '10%', '10%', '10%', '6%', '12%'],
        body: [
          headerRow,
          ...processedBody
        ]
      },
      layout: {
        hLineWidth: () => 0.5,
        vLineWidth: () => 0,
        hLineColor: () => '#aaa'
      },
      margin: [20, 0, 20, 0],
      ...(pageBreak ? { pageBreak } : {})
    };
  }

  function generateEmployeeSections(fields: any[], params: any): Content[] {
    const MAX_ROWS_PER_PAGE = 11;
    const content: Content[] = [];

    let currentEmployeeId: any = null;
    let currentTableBody: any[][] = [];
    let previousDate: string = '';
    let rowCount = 0;
    let summary = {};

    const flushEmployeePages = (employeeRecord: any) => {
      if (currentTableBody.length === 0) return;

      const chunks = [];
      for (let i = 0; i < currentTableBody.length; i += MAX_ROWS_PER_PAGE) {
        chunks.push(currentTableBody.slice(i, i + MAX_ROWS_PER_PAGE));
      }

      chunks.forEach((chunk, index) => {
        if (chunk.length > 0) {
          if (!chunk[0][0].text) {
            let forcedDate = '';
            const chunkStartIndex = index * MAX_ROWS_PER_PAGE;

            for (let i = chunkStartIndex; i >= 0; i--) {
              if (currentTableBody[i][0].text) {
                forcedDate = currentTableBody[i][0].text;
                break;
              }
            }
            chunk[0][0].text = forcedDate;
          }
        }

        const employeeInfo = buildEmployeeInfo(employeeRecord, summary);

        content.push({
          stack: [employeeInfo],
          ...(content.length > 0 || index > 0 ? { pageBreak: 'before' } : {}),
        });

        content.push(buildTableSection(chunk));
      });
    };

    fields.forEach((record, index) => {
      const isNewEmployee = record.employee_id !== currentEmployeeId;

      if (isNewEmployee) {
        flushEmployeePages(fields[index - 1]);
        currentTableBody = [];
        rowCount = 0;
        previousDate = '';
        currentEmployeeId = record.employee_id;
        summary = params.shift_summary?.[currentEmployeeId] || {};
      }

      const showDate = record.date !== previousDate;
      previousDate = record.date;

      currentTableBody.push([
        { text: showDate ? record.date : '', style: 'tableData' },
        {
          text: (() => {
            const parts = (record.shift_time || '').split('\n');
            return [
              { text: parts[0] || '' },
              parts[1] ? { text: '\n' + parts[1], italics: true } : ''
            ];
          })(),
          style: 'tableData',
        },
        { 
          text: record.shift_type === 'D' ? 'Day' : record.shift_type === 'N' ? 'Night' : '',
          style: 'tableData', alignment: 'center' 
        },
        { text: record.clock_in || '', style: 'tableData' },
        { text: record.clock_out || '', style: 'tableData' },
        { text: record.late || '', style: 'tableData', alignment: 'center' },
        { text: record.early_out || '', style: 'tableData', alignment: 'center' },
        { text: record.leave || '', style: 'tableData', alignment: 'center' },
        { text: record.leave_hour || '', style: 'tableData', alignment: 'center' },
        { text: record.ot_hour || '', style: 'tableData', alignment: 'center' },
        {
          text: record.total_hour || '',
          style: 'tableData',
          bold: record.total_hour === 'OFF' || record.total_hour === 'ABSENT' ? true : false,
          alignment: 'center'
        }
      ]);
    });

    if (fields.length) {
      flushEmployeePages(fields[fields.length - 1]);
    }

    return content;
  }

  return {
    pageSize: "A4",
    pageOrientation: 'landscape',
    ...headerSapiensForm,
    content: [
      ...generateEmployeeSections(props.fields, props.params),
    ],
    defaultStyle: {
      font: 'KanitLM',
    },
    styles: {
      ...headerSapiensForm.styles,
      tableHeader: {
        bold: true,
        fontSize: 9,
        margin: [0, 5, 0, 5] 
      },
      tableData: { 
        fontSize: 9,
        margin: [0, 6, 0, 6]
      },
      footerSignature: { fontSize: 9 },
      footerData: { fontSize: 9 },
    },
    footer: function (currentPage: number, pageCount: number) {
      return {
        margin: [20, 0, 20, 10],
        columns: [
          {
            text: `วันที่พิมพ์/Printed date: ${props.params.printed_date}`,
            font: "KanitLM",
            style: "footerData",
            alignment: "left",
            margin: [0, 5, 0, 0],
          },
          {
            text: "",
            width: "*",
          },
          {
            text: `Page ${currentPage} from ${pageCount}`,
            font: "KanitLM",
            style: "footerData",
            alignment: "right",
            margin: [0, 5, 0, 0],
          }
        ]
      };
    },
    images: {
      ...headerSapiensForm.images,
      background: origin + "/static/images/logoform/SAPIENS/HeaderSapiensForm.png",
    },
  };
};

export default FormEmployeeAttendanceReport;
